import { forwardRef } from 'react';
import type { HTMLAttributes, ReactNode } from 'react';
import './Sheet.css';

interface SheetProps extends HTMLAttributes<HTMLElement> {
  side?: 'right' | 'bottom';
  open?: boolean;
  label?: string;
  children?: ReactNode;
}

/**
 * Sheet — a side / bottom drawer. This is chrome (a floating panel), so its
 * CSS uses the Pitch Glass glass treatment by design
 * (docs/ground-up/04_visual_language_pitch_glass.md §3). Keep dense data that
 * lives inside a Sheet on opaque sub-surfaces rather than nested glass.
 */
export const Sheet = forwardRef<HTMLElement, SheetProps>(function Sheet(
  { side = 'right', open = true, label, className = '', children, ...rest },
  ref
) {
  return (
    <aside
      ref={ref}
      data-side={side}
      data-open={open}
      aria-label={label}
      className={`sheet ${className}`.trim()}
      {...rest}
    >
      {children}
    </aside>
  );
});
